<app-table-scrollable *ngIf="dataLoaded" [filterNotRequired]="true" (headerToggled)="changeInHeader($event)"
  [table]="transactionsTable" (paginationChange)="onPaginationChange($event)"></app-table-scrollable>